import { Fragment, useState, useEffect, useCallback, useMemo } from 'react';
import { Link, useParams, useLocation, useNavigate } from 'react-router-dom';
import { pageFormItemLayout } from '@utils/property';
import { Form, Input, Layout, Calendar, Radio, Checkbox, Dropdown, DatePicker, Space, Button, Select, Switch, Upload, Col, Row, Modal, Typography, message, Image, Tag, Cascader, TreeSelect, Alert } from 'antd';
import dayjs from 'dayjs';
import './index.less';
import ImgCrop from 'antd-img-crop';
import RichEditor, { isEffectivelyEmptyRichHtml } from '@components/common/RichEditor';
import { regionOptions } from '@utils/region';
import { departmentTreeToSelectData } from '@utils/utils';
import { fileApi, conferenceSaveApi, conferenceOnceApi, conferenceUpdateApi, changeLaborFeePaymentStatus } from '@services/Conference';
import { getBossStaffs, getBossDepartments } from '@services/Enterprise';
import config from '@config';
import PageHeader from '@components/PageHeader/PageHeader';
import { CONFERENCE_WORKSPACE_PARENT_PATH, CONFERENCE_WORKSPACE_ROUTE_BASE } from '@/layouts/conferenceWorkspaceConfig';
export default function Conference() {
    const [dateValue, setDateValue] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [coverList, setCoverList] = useState([]);
    const [wxCoverList, setWxCoverList] = useState([]);
    const [datePicker, setDatePicker] = useState(undefined);
    const [oneData, setOneData] = useState(false);
    const [dateTrues, setDateTrues] = useState(false);
    const [hide, setHide] = useState(false);
    const [titleName, setTitleName] = useState(undefined);
    const [descriptions, setDescriptions] = useState('');
    const navigate = useNavigate();
    const params = useParams();
    const id = params?.id === 'new' ? null : params?.id;
    const option = { headers: { 'Content-Type': 'multipart/form-data' } };
    const location = useLocation();
    const isEdit = location.state?.edit === 'edit' || !!id;
    const editId = location.state?.id || id || null;
    const [form] = Form.useForm();
    const [staffOptions, setStaffOptions] = useState([]);
    const [departmentTreeData, setDepartmentTreeData] = useState([]);
    const isBusiness = Form.useWatch('isBusiness', form);

    const checkout = (file, size, initWidth, initHeight) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
        // 判断类型
        if (!isJpgOrPng) {
            message.error('只能上传 jpg/png/jpeg 格式');
            setOneData(true);
            return null;
        } else {
            setOneData(false);
        }
        // 判断大小
        const isLt2M = file.size / 1024 / 1024 < size;
        if (!isLt2M) {
            message.error('图像必须小于' + size + 'MB!');
            setOneData(true);
            return null;
        } else {
            setOneData(false);
        }
        return isJpgOrPng && isLt2M;
        // && getFileWidthAndHeight(file, initWidth, initHeight);
    };

    // 获取上传文件 - 前缀
    const getFileUrl = url => {
        if (url && url.includes('https')) {
            return url;
        }
        if (url && !url.includes('https')) {
            return config.OSS_PREFIX + url;
        }
        return null;
    };

    // 分享图
    const shareImageFile = {
        name: 'shareImageFile',
        customRequest: info => {
            const formData = new FormData();
            formData.append('file', info.file); //名字和后端接口名字对应
            formData.append('type', 14);
            if (!oneData) {
                fileApi(formData, option).then(res => {
                    if (!res) {
                        message.error('上传文件失败！！');
                        return false;
                    }
                    if (res.status_code === 200) {
                        setFileList([getFileUrl(res.data)]);
                        form.setFieldValue('shareImageUrl', getFileUrl(res.data));
                    }
                });
            } else {
                form.setFieldValue('shareImageUrl', undefined);
            }
        },
    };

    const coverImageFile = {
        name: 'coverImageFile',
        customRequest: info => {
            const formData = new FormData();
            formData.append('file', info.file); //名字和后端接口名字对应
            formData.append('type', 14);
            if (!oneData) {
                fileApi(formData, option).then(res => {
                    if (!res) {
                        message.error('上传文件失败！！');
                        return false;
                    }
                    if (res.status_code === 200) {
                        setCoverList([getFileUrl(res.data)]);
                        form.setFieldValue('cover', getFileUrl(res.data));
                    }
                });
            } else {
                form.setFieldValue('cover', undefined);
            }
        },
    };

    // 微信小程序分享卡片图
    const wxCoverImageFile = {
        name: 'wxCoverImageFile',
        customRequest: info => {
            const formData = new FormData();
            formData.append('file', info.file);
            formData.append('type', 14);
            if (!oneData) {
                fileApi(formData, option).then(res => {
                    if (!res) {
                        message.error('上传文件失败！！');
                        return false;
                    }
                    if (res.status_code === 200) {
                        setWxCoverList([getFileUrl(res.data)]);
                        form.setFieldValue('wxCover', getFileUrl(res.data));
                    }
                });
            } else {
                form.setFieldValue('wxCover', undefined);
            }
        },
    };

    const onChange = (date, dateString) => {
        setDatePicker(date);
        // setDateTrues(true);
        let dateList;
        if (dateValue === null) dateList = [];
        else dateList = [...dateValue];

        if (dateList.includes(dateString)) return;

        dateList.push(dateString);
        dateList.sort((a, b) => new Date(a) - new Date(b));

        form.setFieldValue('dates', dateList);
        if (dateList.length > 0) setDateTrues(false);
        setDateValue(dateList);
    };

    const hideChange = (checked, type) => {
        if (type === 'healthcarePlatformHidden') {
            setHide({
                ...hide,
                healthcarePlatformHidden: checked,
            });
        } else if (type === 'hidden') {
            setHide({
                ...hide,
                hidden: checked,
            });
        }
    };

    const disabledDate = d => {
        if (dateValue && dateValue.includes(d.format('YYYY-MM-DD'))) return true;
        else return false || d < dayjs().subtract(1, 'days');
    };

    const onOpenChange = () => {
        setDatePicker(undefined);
    };

    // 氚云编号禁止输入中文字符
    const onH3yunNoChange = e => {
        const raw = e?.target?.value ?? '';
        form.setFieldValue('h3yunNo', raw.replace(/[\u4e00-\u9fa5]/g, ''));
    };

    // 项目劳务需求：与会议项目列表操作列的劳务标记逻辑一致（编辑态即时调接口生效）
    const onLabelPaymentChange = checked => {
        const nextStatus = checked ? 1 : 0;
        // Form 注入的 onChange 已写入 boolean，先还原为切换前状态，待确认/接口成功后再更新
        form.setFieldValue('labelPayment', checked ? 0 : 1);

        if (!isEdit) {
            // 新增态项目尚未创建，仅作为表单值随保存一并提交
            form.setFieldValue('labelPayment', nextStatus);
            return;
        }

        const data = { id: editId, labelPayment: nextStatus };
        if (nextStatus === 0) {
            Modal.confirm({
                title: '变更劳务费需求状态',
                icon: <i className="bi bi-exclamation-circle" aria-hidden="true" />,
                content: (
                    <>
                        变更劳务费需求状态将影响项目劳务进度列表的数据展示，确定<Typography.Text type="danger">标记为无需劳务</Typography.Text>？
                    </>
                ),
                okText: '确认',
                cancelText: '取消',
                centered: true,
                onOk: () => {
                    changeLaborFeePaymentStatus(data).then(res => {
                        if (res.status_code === 200) {
                            message.success('成功标记为无需劳务');
                            form.setFieldValue('labelPayment', 0);
                        }
                    });
                },
            });
        } else {
            changeLaborFeePaymentStatus(data).then(res => {
                if (res.status_code === 200) {
                    message.success('成功标记为需要劳务');
                    form.setFieldValue('labelPayment', 1);
                }
            });
        }
    };

    const onFinish = values => {
        if (!dateValue || dateValue.length === 0) setDateTrues(true);
        form.validateFields().then(() => {
            const addRess = form.getFieldValue('address');
            let provinceCode = '',
                cityCode = '',
                districtCode = '';
            if (addRess) {
                provinceCode = addRess?.[0] ? addRess[0] : '';
                cityCode = addRess?.[1] ? addRess[1] : '';
                districtCode = addRess?.[2] ? addRess[2] : '';
            }

            let dateString = [...dateValue];
            dateString = dateString.join();
            const values = form.getFieldsValue();
            const obj = {
                ...values,
                provinceCode,
                cityCode,
                districtCode,
                dates: dateString,
                hidden: hide.hidden ? 0 : 1,
                healthcarePlatformHidden: hide.healthcarePlatformHidden ? 0 : 1,
                benefitCollectionDeadline: values.benefitCollectionDeadline ? dayjs(values.benefitCollectionDeadline).format('YYYY-MM-DD HH:mm:ss') : '',
                projectOwnerIds: values.projectOwnerIds || [],
                projectDepartmentIds: values.projectDepartmentIds || [],
            };
            // 非经营项目：保留已填氚云编号但不随表单提交
            if (values.isBusiness === 0) {
                delete obj.h3yunNo;
            }
            if (isEdit) {
                obj.id = editId;
                if (dateValue.length > 0) {
                    conferenceUpdateApi({ ...obj }).then(res => {
                        if (res.status_code === 200) {
                            message.success('修改成功');
                            navigate('/conf/conferences');
                        }
                    });
                }
            } else {
                if (dateValue.length > 0) {
                    // console.log(1);
                    conferenceSaveApi({ ...obj }).then(res => {
                        if (res.status_code === 200) {
                            message.success('保存成功');
                            navigate('/conf/conferences');
                        }
                    });
                } else {
                    // console.log(1);
                    setDateTrues(true);
                }
            }
        });
    };

    const onReset = () => {
        navigate('/conf/conferences');
    };

    const removeTag = tag => {
        const dateList = dateValue.filter(item => item !== tag);
        setDateValue(dateList);
        form.setFieldValue('dates', dateList);
    };

    const imageUploadHandler = useCallback(
        async blobInfo => {
            const formData = new FormData();
            formData.append('file', blobInfo.blob());
            formData.append('type', 13);
            const hide = message.loading('上传中...', 0);
            try {
                const res = await fileApi(formData, option);
                const url = getFileUrl(res.data);
                hide();
                return url;
            } catch (e) {
                hide();
                throw e;
            }
        },
        [getFileUrl, option],
    );

    const onDescriptionsChange = v => {
        setDescriptions(v);
    };

    const beforeCropCheck = (file, bool) => {
        if (file.type !== 'image/png' && file.type !== 'image/jpg' && file.type !== 'image/jpeg') {
            message.error('只支持JPG/JPEG/PNG格式。');
            return null;
        }

        if (file.size > 2 * 1024 * 1024) {
            message.error('图片大小不能超过2MB。');
            return null;
        }

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = event => {
                const res = event.target.result;
                const imgDom = document.createElement('img');
                imgDom.src = res;
                imgDom.onload = () => {
                    if (imgDom.width < 750 || imgDom.height < 422) {
                        bool && message.warning('会议项目封面不小于750×422px。');
                        resolve(false);
                    } else {
                        resolve(true);
                    }
                };
            };
            reader.readAsDataURL(file);
        });
    };

    useEffect(() => {
        if (isEdit) {
            conferenceOnceApi({ id: editId }).then(res => {
                if (res.status_code === 200) {
                    let address = [];
                    if (res.data.provinceCode === null || res.data.provinceCode === '') {
                        address = [];
                    } else if (res.data.cityCode === null || res.data.cityCode === '') {
                        address.push(res.data?.provinceCode);
                    } else if (res.data?.districtCode === null || res.data?.districtCode === '') {
                        address.push(res.data?.provinceCode);
                        address.push(res.data?.cityCode);
                    } else {
                        address.push(res.data?.provinceCode);
                        address.push(res.data?.cityCode);
                        address.push(res.data?.districtCode);
                    }
                    const dates = res.data.dates.split(',');
                    setDateValue([...dates]);
                    setFileList([res.data?.shareImageUrl]);
                    setCoverList(res.data?.cover ? [res.data?.cover] : []);
                    setWxCoverList(res.data?.wxCover ? [res.data.wxCover] : []);
                    const hidden = res.data.hidden === 1 ? false : true;
                    const healthcarePlatformHidden = res.data.healthcarePlatformHidden === 1 ? false : true;
                    setHide({ hidden: hidden, healthcarePlatformHidden: healthcarePlatformHidden });
                    const obj = {
                        ...res.data,
                        address,
                        dates,
                        labelPayment: res.data.labelPayment ?? 1,
                        isBusiness: res.data.isBusiness ?? 1,
                        projectOwnerIds: Array.isArray(res.data.projectOwnerIds) ? res.data.projectOwnerIds : [],
                        projectDepartmentIds: Array.isArray(res.data.projectDepartmentIds) ? res.data.projectDepartmentIds : [],
                        benefitCollectionDeadline: res.data.benefitCollectionDeadline ? dayjs(res.data.benefitCollectionDeadline) : undefined,
                    };
                    form.setFieldsValue(obj);
                    setDateTrues(false);
                    setTitleName(res.data.name);
                }
            });
        } else {
        }
    }, []);

    // 加载项目经理（企业人员）与项目归属部门选项
    useEffect(() => {
        getBossStaffs().then(res => {
            if (res?.status_code === 200) {
                setStaffOptions((res.data || []).map(staff => ({ label: staff.name, value: staff.id, disabled: staff.status === 1 })));
            }
        });
        getBossDepartments().then(res => {
            if (res?.status_code === 200) {
                setDepartmentTreeData(departmentTreeToSelectData(res.data));
            }
        });
    }, []);

    useEffect(() => {
        document.title = id ? '编辑会议项目-医会议' : '新增会议项目-医会议';
    }, [id]);

    return (
        <Fragment>
            <PageHeader title={!id ? '新增会议项目' : '项目信息'} breadcrumb={[{ label: '医会议', path: CONFERENCE_WORKSPACE_PARENT_PATH }, ...(id ? [{ label: titleName || '项目信息', path: `${CONFERENCE_WORKSPACE_ROUTE_BASE}/${id}` }] : []), !id ? '新增会议项目' : '项目信息']} />

            <div className="page-route-body conference-edit-page">
                <div className="main-content-body">
                    <Form className="conference-form" {...pageFormItemLayout} form={form} initialValues={{ labelPayment: 1, isBusiness: 1 }}>
                        <Form.Item
                            name="name"
                            label="会议项目名称"
                            rules={[{ required: true, message: '' }]}
                            extra={
                                <span style={{ color: '#fa8c16' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-circle-fill anticon" viewBox="0 0 16 16">
                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                                    </svg>
                                    <span style={{ marginLeft: 4 }}>
                                        会议名称将体现在平台会议列表、专家邀请函、专家劳务费发放短信等处，请填写<b>【项目规范全称】</b>
                                    </span>
                                </span>
                            }
                        >
                            <Input placeholder="输入会议项目名称" maxLength={100} showCount allowClear />
                        </Form.Item>

                        <Form.Item
                            name="slug"
                            label="英文简称"
                            rules={[
                                { required: true, message: '' },
                                { pattern: /^[a-z\d_-]{2,20}$/, message: '英文简称不符合格式要求' },
                            ]}
                            help="英文简称，如 chs2023，小写字母、数字、中划线（-）或下划线（_），限2-20个字符"
                        >
                            <Input placeholder="请输入英文简称" maxLength={20} showCount allowClear />
                        </Form.Item>

                        <Form.Item name="dates" label="会议执行日期" className="conference_date_edit">
                            <div>
                                <div className="date_Btn">
                                    <Button onClick={e => e.preventDefault()} size="small" type="text">
                                        <i className="bi bi-plus-circle"></i>
                                        添加日期
                                    </Button>
                                    <DatePicker className="date_Picker" onChange={onChange} onOpenChange={onOpenChange} value={datePicker} />
                                </div>

                                {dateValue && !!dateValue.length && (
                                    <div className="dates" style={{ marginTop: '.5rem' }}>
                                        {dateValue.map(tag => (
                                            <Tag key={tag} closable={true} onClose={() => removeTag(tag)}>
                                                {tag}
                                            </Tag>
                                        ))}
                                    </div>
                                )}
                                {(dateValue && dateValue.length === 0) || dateTrues ? <span className="conference_error">请添加日期</span> : null}
                            </div>
                        </Form.Item>

                        <Form.Item name="labelPayment" label="需要劳务" getValueProps={value => ({ checked: value === 1 })} rules={[{ required: true, message: '请选择是否需要劳务' }]} extra='请按实际需求选择，若选择"否"该项目将无法使用劳务费功能。'>
                            <Switch checkedChildren="是" unCheckedChildren="否" onChange={onLabelPaymentChange} />
                        </Form.Item>

                        <Form.Item label="经营项目" required>
                            <Space size="middle" align="center">
                                <Form.Item name="isBusiness" noStyle getValueProps={value => ({ checked: value === 1 })} rules={[{ required: true, message: '请选择是否为经营项目' }]}>
                                    <Switch checkedChildren="是" unCheckedChildren="否" onChange={checked => form.setFieldValue('isBusiness', checked ? 1 : 0)} />
                                </Form.Item>
                                {isBusiness === 1 && (
                                    <>
                                        <span>氚云项目编号</span>
                                        <Form.Item name="h3yunNo" noStyle rules={[{ required: true, message: '请输入氚云项目编号' }]}>
                                            <Input placeholder="输入氚云编号" maxLength={20} allowClear style={{ width: 200 }} onChange={onH3yunNoChange} />
                                        </Form.Item>
                                    </>
                                )}
                            </Space>
                        </Form.Item>

                        <Form.Item name="projectOwnerIds" label="项目经理" rules={[{ required: true, message: '请选择项目经理' }]}>
                            <Select mode="multiple" placeholder="请选择项目经理" options={staffOptions} showSearch optionFilterProp="label" allowClear />
                        </Form.Item>

                        <Form.Item name="projectDepartmentIds" label="项目归属部门" rules={[{ required: true, message: '请选择项目归属部门' }]}>
                            <TreeSelect multiple placeholder="请选择项目归属部门" treeData={departmentTreeData} showSearch treeNodeFilterProp="title" treeDefaultExpandAll allowClear />
                        </Form.Item>

                        <Form.Item name="benefitCollectionDeadline" label="权益提交截止">
                            <DatePicker placeholder="请选择权益提交截止时间" style={{ width: '100%' }} format="YYYY-MM-DD HH:mm" showTime={{ format: 'HH:mm' }} />
                        </Form.Item>

                        <Form.Item name="type" label="会议形式" rules={[{ required: true, message: '请选择会议形式' }]}>
                            <Radio.Group>
                                <Radio value={3}>线上 + 线下</Radio>
                                <Radio value={1}>线上</Radio>
                                <Radio value={2}>线下</Radio>
                            </Radio.Group>
                        </Form.Item>

                        <Form.Item required label="会议项目封面" extra="支持JPG/PNG格式，建议尺寸 1500*844px（不小于 750*422px，比例16:9），文件大小不超过2MB" className="share-image">
                            <Form.Item name="cover" noStyle rules={[{ required: true, message: '请上传会议项目封面' }]}>
                                <input type="hidden" />
                            </Form.Item>
                            {coverList.length > 0 && <Image width={200} src={coverList[0]} className="share-image-area" alt="会议项目封面预览" />}
                            <ImgCrop
                                aspect={16 / 9}
                                minZoom={0.1}
                                maxZoom={2}
                                beforeCrop={async file => {
                                    const res = await beforeCropCheck(file, true);
                                    return res;
                                }}
                            >
                                <Upload beforeUpload={file => checkout(file, 2, 300, 300)} fileList={coverList} {...coverImageFile} maxCount={1}>
                                    <Button icon={<i className="bi bi-upload"></i>}>{coverList.length > 0 ? '更改图片' : '上传图片'}</Button>
                                </Upload>
                            </ImgCrop>
                        </Form.Item>

                        <Form.Item name="intro" label="会议项目简介" rules={[{ required: true, message: '' }]} help="项目简介主要用于会议项目列表处简单介绍性文字">
                            <Input.TextArea rows={3} maxLength={200} showCount />
                        </Form.Item>

                        <Form.Item
                            name="description"
                            label="会议项目介绍"
                            rules={[
                                {
                                    validator: async (_, value) => {
                                        if (isEffectivelyEmptyRichHtml(value)) {
                                            return Promise.reject('请输入会议项目介绍');
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                        >
                            <RichEditor id="conference-description" mode="full" value={descriptions ?? ''} onChange={onDescriptionsChange} imageUploadHandler={imageUploadHandler} className="react-editor" />
                        </Form.Item>

                        <Form.Item name="address" label="城市">
                            <Cascader options={regionOptions} placeholder="请选择城市" changeOnSelect />
                        </Form.Item>

                        <Form.Item name="place" label="场地">
                            <Input placeholder="输入会议举办场地" allowClear />
                        </Form.Item>

                        <Form.Item
                            label="微信小程序分享卡片"
                            name="wxCover"
                            extra={
                                <>
                                    <div>支持JPG/PNG格式，建议尺寸 1000&times;800px（不小于 500&times;400px），比例5:4，大小不超过2MB</div>
                                    <Alert type="warning" showIcon title="若会议以小程序形式分享，必须上传小程序分享图，否则分享图显示比例会异常" />
                                </>
                            }
                        >
                            {wxCoverList.length > 0 && <Image width={200} src={wxCoverList[0]} className="share-image-area" alt="微信小程序分享卡片图预览" />}
                            <div>
                                <Upload beforeUpload={file => checkout(file, 2)} fileList={wxCoverList} {...wxCoverImageFile} maxCount={1}>
                                    <Button icon={<i className="bi bi-upload"></i>}>{wxCoverList.length > 0 ? '更改图片' : '上传图片'}</Button>
                                </Upload>
                            </div>
                        </Form.Item>

                        <Form.Item name="shareTitle" label="微信分享标题" rules={[{ required: true, message: '' }]}>
                            <Input placeholder="输入分享标题" maxLength={30} showCount allowClear />
                        </Form.Item>

                        <Form.Item name="shareDesc" label="微信分享描述" rules={[{ required: true, message: '' }]}>
                            <Input placeholder="输入分享描述" maxLength={30} showCount allowClear />
                        </Form.Item>

                        <Form.Item required label="微信分享图" extra="支持JPG/PNG格式，尺寸300&times;300px，大小不超过2M" className="share-image">
                            <Form.Item name="shareImageUrl" noStyle rules={[{ required: true, message: '请上传微信分享图' }]}>
                                <input type="hidden" />
                            </Form.Item>
                            {fileList.length > 0 && <Image width={200} src={fileList[0]} className="share-image-area" alt="微信分享图预览" />}
                            <Upload beforeUpload={file => checkout(file, 2, 300, 300)} fileList={fileList} {...shareImageFile} maxCount={1}>
                                <Button icon={<i className="bi bi-upload"></i>}>{fileList.length > 0 ? '更改图片' : '上传图片'}</Button>
                            </Upload>
                        </Form.Item>

                        <div className="page-form-foot-operations">
                            <Space size="large">
                                <Button type="primary" size="large" htmlType="submit" onClick={onFinish}>
                                    提交
                                </Button>
                                <Button type="default" size="large" onClick={onReset}>
                                    取消
                                </Button>
                            </Space>
                        </div>
                    </Form>
                </div>
            </div>
        </Fragment>
    );
}
